import { render, staticRenderFns } from "./TheSiteSidebarCustomerTwo.vue?vue&type=template&id=ddf3ca34"
import script from "./TheSiteSidebarCustomerTwo.vue?vue&type=script&lang=js"
export * from "./TheSiteSidebarCustomerTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddf3ca34')) {
      api.createRecord('ddf3ca34', component.options)
    } else {
      api.reload('ddf3ca34', component.options)
    }
    module.hot.accept("./TheSiteSidebarCustomerTwo.vue?vue&type=template&id=ddf3ca34", function () {
      api.rerender('ddf3ca34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/TheSiteSidebarCustomerTwo.vue"
export default component.exports